<template>
  <div class="page-statistics-container">
    <div class="statistics-container" :style="{ 'border-top': '1px solid #f0f0f0' }">
      <label class="statistics-label">
        문제 정답률
      </label>
      <div class="statistics">
        {{ correctRate }}%
      </div>
    </div>
    <div class="statistics-container">
      <label class="statistics-label">
        내풀이시간/평균풀이시간
      </label>
      <div class="statistics">
        {{ myQuizSolveDuration }} / {{ totalDuration || '-' }}초
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty, ceil, isNumber } from 'lodash';

export default {
  name: 'cat-page-statistics',

  props: {
    quizResult: {
      type: Object,
      default: () => {},
    },
    quizResultCache: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    averageDuration() {
      if (isEmpty(this.quizResultCache)) return 0;
      const correctAnswerCount = this.quizResultCache.correct_count || 0;
      const correctAnswerDuration = this.quizResultCache.correct_duration || 0;
      return correctAnswerCount > 0 ? ceil(correctAnswerDuration / correctAnswerCount) : null;
    },

    correctAnswerRate() {
      if (isEmpty(this.quizResultCache)) return 0;
      const correctAnswerCount = this.quizResultCache.correct_count || 0;
      const totalAnswerCount = this.quizResultCache.total_count;
      return totalAnswerCount > 0 ? ceil((correctAnswerCount / totalAnswerCount) * 100) : null;
    },

    correctRate() {
      if (isNumber(this.correctAnswerRate)) return this.correctAnswerRate;
      return (this.quizResult.is_correct ? '100' : '0');
    },

    myQuizSolveDuration() {
      if (isEmpty(this.quizResult)) return '-';
      return ceil(this.quizResult.duration) || '-';
    },

    totalDuration() {
      if (isNumber(this.averageDuration)) return this.averageDuration;
      return this.myQuizSolveDuration;
    },
  },
};
</script>

<style lang="scss" scoped>
  .page-statistics-container {
    max-width: 570px;
    padding: 0 16px 20px 16px;
    margin: 0 auto;

    .statistics-container {
      border-bottom: 1px solid #f0f0f0;
      padding: 14px 0 14px 0;

      .statistics-label {
        color: #808080;
        margin-bottom: 0;
        font-size: 14px;
      }

      .statistics {
        color: #9013fe;
        font-size: 14px;
        float: right;
      }
    }
  }
</style>
